import { render, staticRenderFns } from "./top-menu-item.vue?vue&type=template&id=bd8d93fe"
import script from "./top-menu-item.vue?vue&type=script&lang=js"
export * from "./top-menu-item.vue?vue&type=script&lang=js"
import style0 from "./top-menu-item.vue?vue&type=style&index=0&id=bd8d93fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports